module.exports = {"Create Role":"创建身份","Create User":"创建用户","Lists":"列表视图","Normal View":"普通模式","Nested View":"嵌套资源","Parallel View":"平行资源"}


//////////////////
// WEBPACK FOOTER
// ./examples/lang/test-zh-Hans.json
// module id = 323
// module chunks = 0